/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react';
import * as React from 'react';
import { getFormattedValue } from 'src/utils/getFormattedValue';

import { assignEpic } from '../../api/useAgileService';
import { SprintTask, useAgileStore } from '../../store';
const { useState, useEffect } = React;

export const EpicCell = ({ task }: { task: SprintTask }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [epic, setEpic] = useState({
    id: '',
    color: '',
    name: '',
  });
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const { epics, setItem } = useAgileStore();

  useEffect(() => {
    if (task?.epicRef) {
      const selectedEpic = epics.find((epic) => epic._id === task.epicRef);
      if (selectedEpic) {
        setEpic({
          id: selectedEpic._id,
          color: selectedEpic.name[0].children[0].color,
          name: selectedEpic.name[0].children[0].text,
        });
      }
    }
  }, [task?.epicRef]);

  const handleEpicCell = (item) => {
    setEpic({
      id: item?._id ? item?._id : '',
      color: item?.name ? item.name[0].children[0].color : '',
      name: item?.name ? item.name[0].children[0].text : '',
    });
    assignEpic(task._id, item._id);
    setItem(
      {
        ...task,
        epicRef: item._id,
      },
      task._id
    );
  };

  // const handleChange = (value) => {

  // };
  return (
    <React.Fragment>
      <Menu isOpen={isOpen} onClose={close} onOpen={open}>
        <MenuButton as="div" className="h-50 w-full flex items-center py-8 pl-30">
          <button className="flex justify-between w-full ">
            <span
              className="leading-10 px-6 py-4 text-xs font-semibold text-white rounded-sm block mr-4 max-w-185 truncate"
              style={{ backgroundColor: epic.id ? epic.color || '#ccc' : '' }}
            >
              {epic.name}
            </span>
          </button>
        </MenuButton>

        <Portal>
          <div className="more-menu-popover">
            <MenuList>
              <div
                className=" min-w-200 p-16 rounded-lg z-100 bg-white"
                style={{ boxShadow: '0px 2px 16px rgba(19, 23, 32, 0.12)' }}
              >
                <div className="max-h-384 overflow-y-auto ">
                  {epics.length > 0 ? (
                    epics.map((epic) => {
                      return (
                        <MenuItem
                          style={{ lineHeight: '10px' }}
                          key={`${epic._id}`}
                          onClick={handleEpicCell.bind(null, epic)}
                          className=" w-full py-4 font-semibold text-white rounded-sm px-6"
                        >
                          <button className="flex  justify-between w-full text-black">
                            <span
                              className="inline-block px-6 rounded-sm text-xs py-4"
                              // style={{ backgroundColor: epic.name[0].children[0].color || '#ccc' }}
                            >
                              {getFormattedValue(epic.name)}
                            </span>
                          </button>
                        </MenuItem>
                      );
                    })
                  ) : (
                    <>
                      <div className="p-8 text-sm text-gray-600">No epics created</div>
                    </>
                  )}
                </div>
              </div>
            </MenuList>
          </div>
        </Portal>
      </Menu>
    </React.Fragment>
  );
};
